import GetLabel from 'foundation/js/getLabel'
import debounce from 'foundation/js/debounce'
import { useStore } from 'vuex'
import { computed, onMounted, ref } from 'vue'
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'
export default {
    name: 'SearchOverlay',
    setup() {
        let first, last, close

        const store = useStore()
        const results = computed(
            () => store.state.search.autocomplete_result?.entries ?? []
        )
        const showSpinner = computed(
            () => store.state.search.autocomplete_inprogress
        )

        const inputText = ref('')
        const termInput = function () {
            if(!hideAutoComplete()) {
                debounce(() => {
                    store.dispatch('search/getAutocomplete', {
                        query: inputText.value
                    })
                }, 500)()
            }
        }

        const tabTrap = function (e) {
            if (!results.value.length) {
                e.preventDefault()
                close.focus()
                return false
            }

            if (e.shiftKey && e.target.dataset.order === 'first') {
                e.preventDefault()
                last.focus()
            }

            if (!e.shiftKey && e.target.dataset.order === 'last') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && !e.target.dataset.order) {
                e.preventDefault()
                first.focus()
            }
        }

        const searchPageUrl = function (query) {
            return store.state.search.search_page_redirecturl + '?q=' + query
        }

        const hideAutoComplete = function () {
            return store.state.search.hide_autocomplete
        }

        const redirectToSearchPage = function () {
            location.href = searchPageUrl(inputText.value)
        }

        onMounted(() => {
            store.dispatch('search/initAutocomplete')
            first = document.querySelector(
                '.kb-search-overlay [data-order="first"]'
            )
            last = document.querySelector(
                '.kb-search-overlay__result[data-order="last"]'
            )
            close = document.querySelector('.kb-page-overlay__close')
            onTransitionendCallback(
                {
                    opening() {
                        first.focus()
                    }
                },
                { persistent: true }
            )
        })

        return {
            getLabel: (labelKey) => GetLabel({ labelKey, labelCollection: 'searchOverlay' }),
            redirectToSearchPage,
            searchPageUrl,
            results,
            showSpinner,
            termInput,
            tabTrap,
            inputText
        }
    }
}
